import { render } from "./add-order.vue?vue&type=template&id=8a8ef8ac&scoped=true"
import script from "./add-order.vue?vue&type=script&lang=js"
export * from "./add-order.vue?vue&type=script&lang=js"

import "./add-order.vue?vue&type=style&index=0&id=8a8ef8ac&scoped=true&lang=css"
import "./add-order.vue?vue&type=style&index=1&id=8a8ef8ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8ef8ac"]])

export default __exports__